import { render, staticRenderFns } from "./TextAreaType.vue?vue&type=template&id=2fcfe3a9&"
import script from "./TextAreaType.vue?vue&type=script&lang=js&"
export * from "./TextAreaType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fcfe3a9')) {
      api.createRecord('2fcfe3a9', component.options)
    } else {
      api.reload('2fcfe3a9', component.options)
    }
    module.hot.accept("./TextAreaType.vue?vue&type=template&id=2fcfe3a9&", function () {
      api.rerender('2fcfe3a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomField/types/TextAreaType.vue"
export default component.exports